module.exports = __webpack_public_path__ + "img/null-data@2x.9eb77704.png";